import { MapEntity } from "../../../../lib/gamemap/MapEntity";
import * as leaflet from "leaflet";
import Properties from "../../widgets/Properties";
import { identity } from "lodash";
import { C } from "../../../../lib/ui/constructors";
import { direction } from "../../../../lib/runescape/movement";
import { TileArea } from "../../../../lib/runescape/coordinates/TileArea";
import assert from "assert";
import { floor_t } from "../../../../lib/runescape/coordinates";
import { FloorLevels, ZoomLevels } from "../../../../lib/gamemap/ZoomLevels";
import TeleportIcon from "../../widgets/TeleportIcon";
var vbox = C.vbox;
var entity = C.entity;
import { LeafletUtils } from "../../../../lib/gamemap/LeafletUtils";
import { LeafletPolygonConstructors } from "../../../../lib/gamemap/LeafletPolygonConstructors";
var areaPolygon = LeafletPolygonConstructors.areaPolygon;
export class TeleportSpotEntity extends MapEntity {
    constructor(teleport) {
        super();
        this.teleport = teleport;
        this.zoom_sensitivity_layers = MapEntity.default_zoom_scale_layers;
        this.floor_sensitivity_layers = undefined;
        this.zoom_sensitivity_layers = new ZoomLevels([
            { min: -100, value: { scale: 0.5 } },
            { min: 1.5, value: { scale: 1 } },
        ]);
        this.floor_sensitivity_layers = new FloorLevels([
            { floors: [teleport.targetArea().origin.level], value: { correct_level: true } },
            { floors: floor_t.all, value: { correct_level: false } },
        ]);
        this.setTooltip(() => new TeleportSpotEntity.TeleportSpotProperties(this.teleport));
    }
    bounds() {
        return TileArea.toRect(this.teleport.targetArea());
    }
    async render_implementation(options) {
        const floor_group = this.floor_sensitivity_layers.get(options.floor_group_index);
        const scale = (options.highlight ? 1.5 : (this.zoom_sensitivity_layers.get(options.zoom_group_index).value.scale));
        const marker = leaflet.marker(LeafletUtils.latLongFromVector2(this.teleport.spot.icon_position_override ?? this.teleport.centerOfTarget()), {
            icon: new TeleportSpotEntity.TeleportMapIcon(this.teleport, scale, w => {
                if (!floor_group.value.correct_level)
                    w.css("filter", "grayscale(1) brightness(0.5)");
                return w;
            }),
            riseOnHover: true,
            interactive: true,
            bubblingMouseEvents: true
        }).addTo(this);
        if (options.highlight) {
            areaPolygon(this.teleport.targetArea())
                .setStyle({
                fillColor: "lightgreen",
                color: "lightgreen",
                stroke: true
            }).addTo(this);
        }
        return marker.getElement();
    }
    async contextMenu(event) {
        const teleport = this.teleport;
        const jumpable_accesses = teleport.group.access.filter(a => a.type == "entity");
        if (jumpable_accesses.length > 0) {
            event.addForEntity({
                type: "submenu",
                text: "Jump to Access",
                children: jumpable_accesses.map(a => {
                    assert(a.type == "entity");
                    return {
                        type: "basic",
                        text: () => entity(a.name),
                        handler: () => {
                            this.parent?.getMap()?.fitView(TileArea.toRect(a.clickable_area));
                        }
                    };
                })
            });
        }
        return {
            type: "submenu",
            icon: `assets/icons/teleports/${teleport.image().url}`,
            text: teleport.hover(),
            children: []
        };
    }
}
(function (TeleportSpotEntity) {
    var cls = C.cls;
    var hbox = C.hbox;
    class TeleportMapIcon extends leaflet.DivIcon {
        createIcon(oldIcon) {
            const scale = this.scale;
            const SIZE = 30;
            return this.transformer(C.div(this.tele.code() ?? "")
                .css2({
                "background-image": `url("./assets/icons/teleports/${this.tele.image().url}")`,
                color: "white",
                width: `${scale * SIZE}px`,
                height: `${scale * SIZE}px`,
                "line-height": `${scale * SIZE}px`,
                "margin": `-${scale * SIZE / 2}px`,
                "font-size": `${scale * 12}px`
            })
                .addClass("marktele")).raw();
        }
        constructor(tele, scale = 1, transformer = identity) {
            super({
                iconSize: [0, 0],
                iconAnchor: [0, 0],
            });
            this.tele = tele;
            this.scale = scale;
            this.transformer = transformer;
        }
    }
    TeleportSpotEntity.TeleportMapIcon = TeleportMapIcon;
    function accessNameAsWidget(access) {
        switch (access.type) {
            case "spellbook":
                return c().text(access.name);
            case "item":
            case "entity":
                return entity(access.name);
        }
    }
    TeleportSpotEntity.accessNameAsWidget = accessNameAsWidget;
    class TeleportSpotProperties extends Properties {
        constructor(teleport) {
            super();
            this.teleport = teleport;
            const props = this;
            const icon = cls("ctr-neosolving-path-stepicon").append(new TeleportIcon(this.teleport)
                .css2({
                "display": "inline-block",
                "height": "20px"
            }));
            props.header(hbox(icon, C.space(), `${teleport.group.name} - ${teleport.spot.name}`));
            TeleportSpotProperties.renderBody(this.teleport, this);
        }
    }
    TeleportSpotEntity.TeleportSpotProperties = TeleportSpotProperties;
    (function (TeleportSpotProperties) {
        function renderBody(teleport, props) {
            if (teleport.access) {
                props.named("Accessed by", renderAccess(teleport.access));
            }
            props.named("Time", `${teleport.props.menu_ticks + teleport.props.animation_ticks} (${teleport.props.menu_ticks} menu + ${teleport.props.animation_ticks} animation)`);
            props.named("Static", teleport.spot.target.size ? "No" : "Yes");
            if (teleport.spot.facing != null) {
                props.named("Orientation", direction.toString(teleport.spot.facing));
            }
            function renderAccess(access) {
                switch (access.type) {
                    case "spellbook":
                        return C.div().text(access.name);
                    case "item":
                    case "entity":
                        return c().append(entity(access.name));
                }
            }
            const alternative_accesses = teleport.group.access.filter(a => a != teleport.access);
            if (alternative_accesses.length > 0) {
                props.named(teleport.access ? "Alternative Access" : "Access", vbox(...alternative_accesses.map(renderAccess)));
            }
        }
        TeleportSpotProperties.renderBody = renderBody;
    })(TeleportSpotProperties = TeleportSpotEntity.TeleportSpotProperties || (TeleportSpotEntity.TeleportSpotProperties = {}));
})(TeleportSpotEntity || (TeleportSpotEntity = {}));
